export var ShortCountry = function (ShortCountry) {
  ShortCountry["UK"] = "UK";
  ShortCountry["GB"] = "GB";
  ShortCountry["DE"] = "DE";
  return ShortCountry;
}({});